import { render, staticRenderFns } from "./entity-tabs.vue?vue&type=template&id=cfd1390e&scoped=true&"
import script from "./entity-tabs.ts?vue&type=script&lang=ts&"
export * from "./entity-tabs.ts?vue&type=script&lang=ts&"
import style0 from "./entity-tabs.scss?vue&type=style&index=0&id=cfd1390e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd1390e",
  null
  
)

export default component.exports